import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./components/home/Home";
import Login from "./components/login/Login";
import PublicRoute from "./router/PublicRoute";
import PrivateRoute from "./router/PrivateRoute";
import Layout from "./components/login/Layout";
import { Toaster } from "react-hot-toast";
import Administration from "./components/administration/Administration";
import Register from "./components/register/Register";
import EditUser from "./components/administration/screens/EditUser";
import InsertUser from "./components/administration/screens/InsertUser";
import UserManagement from "./components/administration/screens/UserManagement";
import InstitututionManagement from "./components/administration/screens/InstitututionManagement";
import InsertInstitution from "./components/administration/screens/InsertInstitution";
import OJManagement from "./components/administration/screens/OJManagement";
import InsertOfficialJournal from "./components/administration/screens/InsertOfficialJournal";
import InsertRegister from "./components/register/srceens/InsertRegister";
import ManagementRegister from "./components/register/srceens/ManagementRegister";
import Help from "./components/help/Help";
import OJInsertDate from "./components/administration/screens/OJInsertDate";
import OJManagamentDate from "./components/administration/screens/OJManagamentDate";
import TUManagement from "./components/administration/screens/TUManagement";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import srLatn from "date-fns/locale/sr-Latn";
import ChangeInstitution from "./components/administration/screens/ChangeInstitution";
import EditRegister from "./components/register/srceens/EditRegister";
import Jurisdiction from "./components/jurisdiction/jurisdiction";
import HelpPage from "./components/help/screens/HelpPage";
import InstitutionUpdating from "./components/administration/screens/InstitutionUpdating";
import Views from "./components/views/Views";
import SearchRegister from "./components/views/screens/SearchRegister";
import InternConvInsert from "./components/administration/screens/InternConvInsert";
import InternConvManagement from "./components/administration/screens/InternConvManagement";
import Measure from "./components/measure/Measure";
import SearchMeasure from "./components/measure/screens/SearchMeasure";
import CelexInstitutionView from "./components/views/screens/CelexInstitutionView";
import CelexNPIView from "./components/views/screens/CelexNPIView";
import QuartalView from "./components/views/screens/QuartalView";
import EuInsert from "./components/administration/screens/EuInsert";
import NPAAView from "./components/views/screens/NPAAView";
import AddMeasure from "./components/register/srceens/AddMeasure";
import MeasureView from "./components/views/screens/MeasureView";
import MeasureEdit from "./components/register/srceens/MeasureEdit";
import MeasureManagement from "./components/register/srceens/MeasureManagement";
import ExpidentureManagament from "./components/register/srceens/ExpidentureManagament";
import ExpidentureView from "./components/views/screens/ExpendituresView";
import ClusterView from "./components/views/screens/ClusterView";
import FinancingMain from "./components/register/FinancingMain";
import Parametrization from "./components/administration/screens/Parametrization";
import ChangeRegisterJur from "./components/register/ChangeRegisterJur";
import LockEditing from "./components/administration/screens/LockEditing";
import ReportsHome from "./components/reports/ReportsHome";
import NationalMeasuresReport from "./components/reports/components/NationalMeasuresReport";
import MeasuresReport from "./components/reports/components/MeasuresReport";
import NewFeatureModal from "./components/modals/NewFeatureModal";
import { useUser } from "./auth/UseUser";
import ReportingConfig from "./components/administration/screens/ReportingConfig";
import ReportingQuarterSelect from "./components/reports/components/ReportingQuarterSelect";
import AdminRoute from "./router/AdminRoute";
import SmtpConfig from "./components/smtp-config/SmtpConfig";
import EmailLogs from "./components/administration/screens/EmailLogs";
import PasswordReset from "./components/login/PasswordReset";
import NewPassword from "./components/login/NewPassword";
import { lockEditingStatus } from "./server/server";

function App() {
  const [showNewFeatureModal, setShowNewFeatureModal] = React.useState(false);
  const { user } = useUser();
  const [reportLocked, setReportLocked] = useState(false);

  const fetchCurrentStatusData = async () => {
    const response = await lockEditingStatus();
    if (response.status === 200) setReportLocked(response.data.isActive);
  };

  useEffect(() => {
    checkShowNewFeatureModal();
    fetchCurrentStatusData();
  }, [user]);

  const checkShowNewFeatureModal = () => {
    const hasSeenModal = localStorage.getItem("newFeatureModalShown_v1");

    if (!hasSeenModal && Object.keys(user).length > 0) {
      setShowNewFeatureModal(true);
    } else return;
  };

  const disabled =
    !user?.roleView?.features?.includes("administration") && reportLocked;

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns} locale={srLatn}>
        <Routes>
          <Route path="/login" element={<PublicRoute Component={Login} />} />
          <Route
            path="password-reset"
            element={<PublicRoute Component={PasswordReset} />}
          />
          <Route
            path="reset-password"
            element={<PublicRoute Component={NewPassword} />}
          />
          <Route path="/" element={<Layout />}>
            <Route index element={<PrivateRoute Component={Home} />} />

            <Route
              path="administration/"
              element={<AdminRoute Component={Administration} />}
            >
              <Route path="smtpConfig" element={<SmtpConfig />} />
              <Route path="emailLogs" element={<EmailLogs />} />
              <Route path="user/edit" element={<EditUser />} />
              <Route path="user/insert" element={<InsertUser />} />
              <Route path="intconv/insert" element={<InternConvInsert />} />
              <Route path="intconv/edit" element={<InternConvInsert />} />
              <Route
                path="intconv/management"
                element={<InternConvManagement />}
              />
              <Route path="user/management" element={<UserManagement />} />
              <Route
                path="institution/management"
                element={<InstitututionManagement />}
              />
              <Route
                path="institution/change"
                element={<ChangeInstitution />}
              />
              <Route
                path="institution/insert"
                element={<InsertInstitution />}
              />
              <Route path="parameters" element={<Parametrization />} />
              <Route path="locking" element={<LockEditing />} />
              <Route path="reporting" element={<ReportingConfig />} />
              <Route path="institution/edit" element={<InsertInstitution />} />
              <Route
                path="institution/changestructure"
                element={<InstitutionUpdating />}
              />
              <Route path="oj/management" element={<OJManagement />} />
              <Route path="oj/insert" element={<InsertOfficialJournal />} />
              <Route path="oj/edit" element={<InsertOfficialJournal />} />
              <Route path="oj/date/insert" element={<OJInsertDate />} />
              <Route path="oj/date/edit" element={<OJInsertDate />} />
              <Route path="oj/date/management" element={<OJManagamentDate />} />
              <Route path="tu/management" element={<TUManagement />} />
              <Route path="eu/insert" element={<EuInsert />} />
              <Route path="*" element={<Administration />} />
            </Route>
            {!disabled && (
              <Route
                path="register/"
                element={<PrivateRoute Component={Register} />}
              >
                <Route path="edit" element={<EditRegister />} />
                <Route path="changejur" element={<ChangeRegisterJur />} />
                <Route path="addmeasure" element={<AddMeasure />} />
                <Route path="measure/edit" element={<MeasureEdit />} />
                <Route
                  path="measure/management"
                  element={<MeasureManagement />}
                />
                <Route
                  path="financial/expenditures"
                  element={<ExpidentureManagament />}
                />
                <Route path="financing" element={<FinancingMain />} />
                <Route
                  path="financial/expenditure/insert"
                  element={<FinancingMain />}
                />
                <Route
                  path="financial/expenditure/edit"
                  element={<FinancingMain />}
                />
                <Route path="insert" element={<InsertRegister />} />
                <Route path="management" element={<ManagementRegister />} />
              </Route>
            )}
            <Route
              path="jurisdiction/"
              element={<PrivateRoute Component={Jurisdiction} />}
            ></Route>
            <Route path="views/" element={<PrivateRoute Component={Views} />}>
              <Route path="search" element={<SearchRegister />} />
              <Route path="measures" element={<MeasureView />} />
              <Route path="fin" element={<ExpidentureView />} />
              <Route path="npaa/:filterName" element={<NPAAView />} />
              <Route
                path="celexInstitution"
                element={<CelexInstitutionView />}
              />
              <Route path="celexchapter" element={<CelexNPIView />} />\
              <Route path="celexcluster" element={<ClusterView />} />
            </Route>
            <Route
              path="measure/"
              element={<PrivateRoute Component={Measure} />}
            >
              <Route path="search" element={<SearchMeasure />} />
              <Route path="insert" element={<AddMeasure />} />
            </Route>
            <Route path="help/" element={<PrivateRoute Component={Help} />}>
              <Route path="page" element={<HelpPage />} />
            </Route>
            <Route
              path="reporting/"
              element={<PrivateRoute Component={ReportsHome} />}
            >
              <Route
                path="select-quarter/national"
                element={<ReportingQuarterSelect />}
              />
              <Route
                path="select-quarter/measures"
                element={<ReportingQuarterSelect />}
              />
              <Route path="national/:id" element={<NationalMeasuresReport />} />
              <Route path="measures/:id" element={<MeasuresReport />} />
              <Route path="quartalView" element={<QuartalView />} />
            </Route>
          </Route>

          <Route path="*" element={<PublicRoute Component={Login} />} />
        </Routes>
        <Toaster
          position="top-right"
          reverseOrder={false}
          containerStyle={{
            top: 125,
          }}
        />
      </LocalizationProvider>
      {showNewFeatureModal && <NewFeatureModal />}
    </div>
  );
}

export default App;
